import { ca } from '@cian/analytics';

import { TThunkAction } from 'shared/types/redux';
import { EObjectType, getCustomUrl } from 'shared/utils/formatters/getCustomUrl';

import { getCoworkingData, getOfferData, getPageData, getUserData } from '../selectors';

export interface ITrackBookingButtonClick {
  offerId?: number;
  gaObjectType?: EObjectType;
}

export const trackBookingButtonClick =
  (analyticParams: ITrackBookingButtonClick = {}): TThunkAction =>
  async (_, getState) => {
    const state = getState();
    const { gaData, custom } = state;
    const { offerId } = analyticParams;

    const productsData = offerId ? getOfferData(state, offerId) : getCoworkingData(state);

    ca('eventSite', {
      name: 'oldevent',
      category: 'Card_CW',
      action: 'CallBack_popup_book_open_blockCW',
      label: getCustomUrl(gaData, custom, analyticParams),
      products: [productsData],
      page: getPageData(state),
      user: getUserData(state),
    });
  };
